import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './PlanInfo.css';
import PlanInfoFeaturesList from './PlanInfoFeaturesList';

interface PlusInfoProps {
    includeHeader?: boolean;
}

const PlusInfo = ({ includeHeader = false }: PlusInfoProps) => {
    const { t } = useTranslation();
    return (
        <>
            {includeHeader && (
                <h1>
                    {t('plan_info_you_are_on', { sprintf: [t('plan_info_type_plus')] })}.{' '}
                    {t('plan_info_whats_included')}:
                </h1>
            )}
            <div className="InfoPage-features">
                <a
                    href="http://support.fieldmargin.com/en/articles/3448658-input-limits"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/inputs.png"
                        alt="Screenshot of field input reporting on the fieldmargin mobile app"
                    />
                    <h2>{t('plan_info_title_unlimited_inputs')}</h2>
                    <p>{t('plan_info_body_unlimited_inputs')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/4480123-how-to-manage-livestock-and-grazing"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/livestock.png"
                        alt="Photo of cows in a shed"
                    />
                    <h2>{t('unlimited_herds')}</h2>
                    <p>{t('plan_info_body_unlimited_livestock')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/5203617-a-complete-guide-to-setting-up-sub-fields"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/sub-fields.png"
                        alt="Screenshot of sub-fields shown on a satellite map"
                    />
                    <h2>{t('field_details_subfields')}</h2>
                    <p>{t('plan_info_body_subfields')}</p>
                </a>
                <a
                    href="http://support.fieldmargin.com/en/articles/6478643-using-reporting"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/full-reporting.png"
                        alt="Screenshot of input cost reporting in fieldmargin"
                    />
                    <h2>{t('full_reporting')}</h2>
                    <p>{t('plan_info_body_full_reporting')}</p>
                </a>
                <a
                    href="http://support.fieldmargin.com/en/articles/6478838-download-your-reports-and-data"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/report-export.png"
                        alt="Photo of a tractor in a field"
                    />
                    <h2>{t('report_export')}</h2>
                    <p>{t('plan_info_body_report_export')}</p>
                </a>
                <a
                    href="http://support.fieldmargin.com/en/articles/4872985-field-use-reporting"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/cropping-summary.png"
                        alt="Screenshot of a field usage pie chart"
                    />
                    <h2>{t('plan_info_title_cropping_summary')}</h2>
                    <p>{t('plan_info_body_cropping_summary')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/6478752-what-is-the-30-day-history-limit"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/history.png"
                        alt="Screenshot of activity list in the fieldmargin web app"
                    />
                    <h2>{t('unlimited_history')}</h2>
                    <p>{t('free_history_desc')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/6367020-yield-recording-and-reporting"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/yield-recording.png"
                        alt="Aerial photo of a combine harvester harvesting a field"
                    />
                    <h2>{t('plan_info_title_yield_recording')}</h2>
                    <p>{t('plan_info_body_yield_recording')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/2380970-printing-your-farm-map"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/map-printing.png"
                        alt="Screenshot of fields shown on a satellite map"
                    />
                    <h2>{t('map_printing')}</h2>
                    <p>{t('plan_info_body_map_printing')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/5672217-using-the-pesticide-list-when-adding-inputs-to-field-jobs"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/pesticides.png"
                        alt="Photo of a farmer inspecting crops"
                    />
                    <h2>{t('inputs_pesticide_database')}</h2>
                    <p>
                        <strong>(UK, South Africa, Australia, Canada, New Zealand)</strong>{' '}
                        {t('plan_info_body_two_pesticides_database')}
                    </p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/1869622-upload-your-paper-farm-maps-to-fieldmargin"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/map-uploader.png"
                        alt="Aerial photo of a field"
                    />
                    <h2>{t('plan_info_title_map_uploader')}</h2>
                    <p>{t('plan_info_body_map_uploader')}</p>
                </a>
            </div>
            <PlanInfoFeaturesList />
        </>
    );
};

export default PlusInfo;
